import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { AppState } from '../core.state';
import { selectAuthentication } from './store/auth.selectors';

export interface Authentication {
  isAuthenticated: boolean;
  isLoading: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  constructor(private store: Store<AppState>) {}

  canActivate(): Observable<boolean> {
    return this.store.pipe(
      select(selectAuthentication),
      first((authentication: Authentication) => !authentication.isLoading),
      map((authentication: Authentication) => authentication.isAuthenticated)
    );
  }
}
